<p>
  camera works!
</p>
